import { useEffect, useRef, useState, type ReactNode } from "react";

export function TeamControlCard({
  color,
  header,
  children,
}: {
  color: string;
  header: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="team-card" style={{ borderColor: color }}>
      <div className="team-card__header">{header}</div>
      <div className="score-controls team-card__actions">{children}</div>
    </div>
  );
}

export function TeamColorControl({
  teamName,
  value,
  onCommit,
}: {
  teamName: string;
  value: string;
  onCommit: (color: string) => void;
}) {
  const [draft, setDraft] = useState(value);
  const lastCommitted = useRef(value);

  useEffect(() => {
    setDraft(value);
    lastCommitted.current = value;
  }, [value]);

  const commit = () => {
    if (draft === lastCommitted.current) return;
    lastCommitted.current = draft;
    onCommit(draft);
  };

  return (
    <input
      aria-label={`Farbe von ${teamName}`}
      type="color"
      value={draft}
      onInput={(event) => setDraft(event.currentTarget.value)}
      onChange={(event) => {
        setDraft(event.currentTarget.value);
        if (event.currentTarget.value !== lastCommitted.current) {
          lastCommitted.current = event.currentTarget.value;
          onCommit(event.currentTarget.value);
        }
      }}
      onBlur={commit}
    />
  );
}
